module.exports = __webpack_public_path__ + "assets/img/robot.6a22b1b5.png";